export function isMobileOrTabletDetected(boolean) {
	return function(dispatch){
		dispatch({
			type: "IS_MOBILE_OR_TABLET_DETECTED",
			payload: boolean
		});
	}
}

export function isLabelSelectedOnMobile (boolean) {
	return function(dispatch){
		dispatch({
			type: "IS_LABEL_SELECTED_ON_MOBILE",
			payload: boolean
		});
	}
}
